module.exports = __webpack_public_path__ + "static/media/CodeQuest-4.0e887467.jpeg";